module.exports = __webpack_public_path__ + "static/media/event_banner.96e93a88.png";